<template>
  <base-row v-bind="$props">
    <td class="flex flex-col">
      <Link
        v-if="hasRoute"
        :href="packageShowRoute"
        class="uppercase font-semibold text-blue-600 hover:text-blue-600"
      >
        {{ item.name || 'Not named' }}
      </Link>
      <span
        v-else
        class="text-blue-600 hover:text-blue-600"
      >
        {{ item.name || 'Not named' }}
      </span>
      Product: {{ item.product_name || 'Not assigned' }}
    </td>

    <td>
      {{ item.batch_num }}
    </td>

    <td>
      {{ item.quantity_available_total }}
    </td>

    <td>
      {{ item.quantity }}
    </td>

    <td>
      {{ item.total_thc ? _percent(item.total_thc) : '-' }}
    </td>

    <td>
      {{ item.product_category }}
    </td>

    <td>
      {{ item.published_at ? _date(item.published_at) : '-' }}
    </td>

    <td>
      <basic-badge
        v-if="item.published_at"
        color="green"
      >
        Published
      </basic-badge>
      <basic-badge
        v-else
        color="gray"
      >
        Draft
      </basic-badge>
    </td>
  </base-row>
</template>

<script>
import { Link } from '@inertiajs/vue3'
import TableRow from '@/Components/Table/TableRow'
import RowProps from '@/Components/Table/Mixins/RowProps'
import _date from '@/Filters/Date'
import _percent from '@/Filters/Percent'
import BasicBadge from '@/Components/Badges/BasicBadge.vue'

export default {
  components: {
    'base-row': TableRow,
    Link,
    BasicBadge
  },

  mixins: [RowProps],

  props: {
    /**
     * A function that we can use to generate the URL to view a package. Returns a string that is a valid URL
     */
    showRoute: {
      type: Function,
      default: (item) => null
    }
  },

  computed: {
    /**
     * Returns the URL we can use to view a package
     */
    packageShowRoute() {
      return this.showRoute(this.item)
    },

    /**
     * Returns true if this package has a valid URL to view a package
     * @returns {boolean}
     */
    hasRoute() {
      return this.packageShowRoute !== null
    }
  },
  methods: {
    _date,
    _percent
  }
}
</script>
